import { useEffect, useState } from 'react';
import logo from '../assets/logo.png';

type Mensagem = {
  de: 'usuario' | 'bot';
  texto: string;
  hora: string;
};

const ROTEIRO: Mensagem[] = [
  { de: 'usuario', texto: 'Registrar entrada 350 venda balcão', hora: '09:12' },
  { de: 'bot', texto: '✅ Entrada registrada: R$ 350,00 – Venda balcão', hora: '09:12' },
  { de: 'usuario', texto: 'Registrar saída 120 fornecedor de bebidas', hora: '09:14' },
  { de: 'bot', texto: '✅ Saída registrada: R$ 120,00 – Fornecedor de bebidas', hora: '09:14' },
  { de: 'usuario', texto: 'Me manda o relatório de hoje', hora: '09:15' },
  { de: 'bot', texto: '📊 Relatório de hoje: Entradas R$ 1.240 · Saídas R$ 380 · Saldo R$ 860', hora: '09:15' },
];

const INTERVALO_MENSAGEM = 1700;
const ATRASO_DIGITANDO = 700;
const PAUSA_FINAL = 2800;

const COR_HEADER_WHATSAPP = '#075E54';
const COR_BOLHA_ENVIADA = '#dcf8c6';

export function TelefoneDemoWhatsApp() {
  const [visiveis, setVisiveis] = useState<Mensagem[]>([]);
  const [digitando, setDigitando] = useState(false);

  useEffect(() => {
    let indice = 0;
    let ativo = true;
    const timeouts: ReturnType<typeof setTimeout>[] = [];

    function proximaMensagem() {
      if (!ativo) return;

      if (indice >= ROTEIRO.length) {
        timeouts.push(
          setTimeout(() => {
            if (!ativo) return;
            setVisiveis([]);
            indice = 0;
            proximaMensagem();
          }, PAUSA_FINAL)
        );
        return;
      }

      const mensagem = ROTEIRO[indice];

      if (mensagem.de === 'bot') {
        setDigitando(true);
        timeouts.push(
          setTimeout(() => {
            if (!ativo) return;
            setDigitando(false);
            setVisiveis((atual) => [...atual, mensagem]);
            indice += 1;
            timeouts.push(setTimeout(proximaMensagem, INTERVALO_MENSAGEM));
          }, ATRASO_DIGITANDO)
        );
      } else {
        setVisiveis((atual) => [...atual, mensagem]);
        indice += 1;
        timeouts.push(setTimeout(proximaMensagem, INTERVALO_MENSAGEM));
      }
    }

    timeouts.push(setTimeout(proximaMensagem, 600));

    return () => {
      ativo = false;
      timeouts.forEach(clearTimeout);
    };
  }, []);

  return (
    <div
      style={{
        width: '270px',
        height: '560px',
        margin: '0 auto',
        background: '#111',
        borderRadius: '38px',
        padding: '12px',
        boxShadow: '0 24px 48px rgba(16,32,61,0.28)',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '12px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '90px',
          height: '18px',
          background: '#111',
          borderRadius: '0 0 14px 14px',
          zIndex: 3,
        }}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          background: '#e5ddd5',
          backgroundImage:
            'radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
          backgroundPosition: '0 0, 12px 12px',
          borderRadius: '28px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Barra de status estilo iPhone */}
        <div
          style={{
            background: COR_HEADER_WHATSAPP,
            color: '#fff',
            fontSize: '11px',
            fontWeight: 600,
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 18px 0',
          }}
        >
          <span>9:41</span>
          <span>📶 🔋</span>
        </div>

        {/* Cabeçalho do WhatsApp */}
        <div
          style={{
            background: COR_HEADER_WHATSAPP,
            color: '#fff',
            padding: '8px 12px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <span style={{ fontSize: '18px', lineHeight: 1 }}>‹</span>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              flexShrink: 0,
            }}
          >
            <img src={logo} alt="Lizzi" width={24} height={24} style={{ objectFit: 'contain' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14px', fontWeight: 700, lineHeight: 1.2 }}>Lizzi Food</div>
            <div style={{ fontSize: '11px', opacity: 0.85, lineHeight: 1.2 }}>online</div>
          </div>
          <span style={{ fontSize: '15px' }}>📹</span>
          <span style={{ fontSize: '15px' }}>📞</span>
        </div>

        <div
          style={{
            flex: 1,
            padding: '12px 10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            overflow: 'hidden',
          }}
        >
          {visiveis.map((mensagem, i) => (
            <div
              key={i}
              style={{
                alignSelf: mensagem.de === 'usuario' ? 'flex-end' : 'flex-start',
                background: mensagem.de === 'usuario' ? COR_BOLHA_ENVIADA : '#ffffff',
                color: '#111b21',
                padding: '7px 9px 6px',
                borderRadius: '8px',
                fontSize: '12px',
                lineHeight: 1.35,
                maxWidth: '85%',
                boxShadow: '0 1px 1px rgba(0,0,0,0.13)',
              }}
            >
              <div>{mensagem.texto}</div>
              <div
                style={{
                  fontSize: '10px',
                  color: '#667781',
                  textAlign: 'right',
                  marginTop: '2px',
                }}
              >
                {mensagem.hora} {mensagem.de === 'usuario' && <span style={{ color: '#53bdeb' }}>✓✓</span>}
              </div>
            </div>
          ))}
          {digitando && (
            <div
              style={{
                alignSelf: 'flex-start',
                background: '#ffffff',
                padding: '8px 12px',
                borderRadius: '8px',
                fontSize: '12px',
                color: '#6b7a90',
                boxShadow: '0 1px 1px rgba(0,0,0,0.13)',
              }}
            >
              digitando…
            </div>
          )}
        </div>

        <div
          style={{
            padding: '8px 10px',
            background: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <div
            style={{
              flex: 1,
              background: '#fff',
              borderRadius: '18px',
              padding: '7px 14px',
              fontSize: '12px',
              color: '#9aa5b3',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <span>😊</span> Mensagem <span style={{ marginLeft: 'auto' }}>📎</span>
          </div>
          <div
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: COR_HEADER_WHATSAPP,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '13px',
              flexShrink: 0,
            }}
          >
            🎤
          </div>
        </div>
      </div>
    </div>
  );
}
